/* eslint-disable camelcase */
import moment from 'moment';
import { from } from 'rxjs';
import { groupBy, mergeMap, reduce, toArray, map, filter } from 'rxjs/operators';
import { getFeaturesTranslations } from '../../../../../feedback/src/helpers/helpers';

const EXPENSES = 'expensas';
const FUNCTION_TYPE = 'function';

export const setGroupMessages = (data, t, leadName) => subscribe => {
  from(data)
    .pipe(
      filter(
        f => f.action_type === undefined || f.action_type === '10' || f.action_type === '6' || f.action_type === '2'
      ),
      map(m => {
        if (m.action_type === '6') {
          m.text = t(`seeker:chat.message.view`, { name: leadName });
        }
        if (m.action_type === '10') {
          m.text = t(`seeker:chat.message.whatsapp`, { name: leadName });
        }

        return m;
      }),
      toArray(),
      map(messages =>
        messages.sort(function s(a, b) {
          return moment(a.date).diff(moment(b.date));
        })
      ),
      mergeMap(a =>
        from(a).pipe(
          groupBy(p => moment(p.date.split('T')[0]).format('YYYY-MM-DD')),
          mergeMap(group$ =>
            group$.pipe(
              reduce(
                (acc, cur) => {
                  return { ...acc, data: [...acc.data, cur] };
                },
                { key: group$.key, data: [] }
              ),
              map(dd => {
                dd.data.sort((aa, bb) => {
                  return moment(aa.date).diff(moment(bb.date));
                });
                return dd;
              })
            )
          )
        )
      ),
      toArray()
    )
    .subscribe(subscribe);
};

export const setGroupMessagesWithResponseMessage = data => subscribe => {
  from(data)
    .pipe(
      toArray(),
      map(messages =>
        messages.sort(function s(a, b) {
          return moment(a.date).diff(moment(b.date));
        })
      ),
      mergeMap(a =>
        from(a).pipe(
          groupBy(p => moment(p.date.split('T')[0]).format('YYYY-MM-DD')),
          mergeMap(group$ =>
            group$.pipe(
              reduce(
                (acc, cur) => {
                  return { ...acc, data: [...acc.data, cur] };
                },
                { key: group$.key, data: [] }
              ),
              map(dd => {
                dd.data.sort((aa, bb) => {
                  return moment(aa.date).diff(moment(bb.date));
                });
                return dd;
              })
            )
          )
        )
      ),
      toArray()
    )
    .subscribe(subscribe);
};
export const formatFeatures = (mainFeatures, t) => {
  const FEATURES_TRANSLATIONS = getFeaturesTranslations(t);

  const labelsMap = {
    [FEATURES_TRANSLATIONS.HAB]: FEATURES_TRANSLATIONS.ROOM_ICON.toLowerCase(),
    [FEATURES_TRANSLATIONS.BATHS_ICON.toLowerCase()]: label =>
      label > 1 ? FEATURES_TRANSLATIONS.BATHS_ICON.toLowerCase() : FEATURES_TRANSLATIONS.BATH_ICON.toLowerCase(),
    [FEATURES_TRANSLATIONS.GARAGE]: FEATURES_TRANSLATIONS.GARAGE_ICON,
    [FEATURES_TRANSLATIONS.SUP_TOTAL]: FEATURES_TRANSLATIONS.TOTAL_ICON
  };

  return mainFeatures
    .filter(item => labelsMap[item.icon] && parseInt(item.label) > 0)
    .map(item => {
      // eslint-disable-next-line valid-typeof
      const labelText =
        // eslint-disable-next-line valid-typeof
        typeof labelsMap[item.icon] === FUNCTION_TYPE
          ? labelsMap[item.icon](parseInt(item.label))
          : labelsMap[item.icon];

      return {
        label: `${item.label} ${item.unit ? item.unit : ''} ${labelText}`
      };
    });
};

export const getFeatureDetails = mainFeatures => {
  return mainFeatures.map(item => {
    const icon = item?.feature?.name;
    const label = item?.value;
    // eslint-disable-next-line camelcase
    const unit = item?.value_unit?.symbol;
    return { icon, label, unit };
  });
};
export const getExpensasValue = mainFeatures => {
  const expensasFeature = mainFeatures.find(item => item?.feature?.name === EXPENSES);
  return expensasFeature?.value || null;
};

export const formatLeadData = ({ posting, publisher }) => {
  const getPictures = () => {
    if (!posting.pictures) return [];
    return Object.keys(posting.pictures).flatMap(resolution =>
      posting.pictures[resolution].map(url => ({
        [resolution]: url
      }))
    );
  };

  const getPublisherLogo = {
    ...publisher.url_logos,
    '130x70': publisher.url_logo
  };

  return {
    ...posting,
    publisher: {
      logo_url: getPublisherLogo,
      name: publisher.name,
      premier: posting.premier
    },
    location: {
      location_level1: posting.location.name,
      location_level2: posting.location.parent.name,
      address: posting.address
    },
    prices: {
      first_price: {
        value: posting.prices?.[0]?.amount,
        currency: posting.prices?.[0]?.currency,
        operationType: posting.prices?.[0]?.operation_type
      },
      second_price: {
        value: posting.prices?.[1]?.amount,
        currency: posting.prices?.[1]?.currency,
        operationType: posting.prices?.[1]?.operation_type
      },
      expenses: {
        value: posting.prices?.[0]?.expenses?.value,
        currency: posting.prices?.[0]?.expenses?.currency
      }
    },
    pictures: getPictures()
  };
};
